<template>
  <b-table :items="items" :fields="fields">
    <template #cell(active-status)="data">
      <b-form-checkbox
        v-model="data.item['active-status']"
        disabled
        :value="true"
        :unchecked-value="false"
        button-variant="success"
      >
      </b-form-checkbox>
    </template>
    <template #cell(name)="data">
      <a :href="`#${data.value.replace(/[^a-z]+/i, '-').toLowerCase()}`">{{data.value}}</a>
    </template>
  </b-table>
</template>

<script>
export default {
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'active-status', label: 'Active' }
      ],
      items: [
        { name: 'Item 1', 'active-status': true },
        { name: 'Item 2', 'active-status': false }
      ]
    };
  }
};

/* 

Using b-table with Read-Only b-switch

To render a read-only b-switch in a b-table cell, you can utilize scoped slots. 
This allows you to customize how each cell is displayed based on the data it contains.
Example Implementation

Here’s a simple example of how to implement a b-switch in a b-table:
Explanation of the Code

    b-table: This component displays the data in a tabular format.
    fields: Defines the columns of the table. In this case, we have "Name" and "Active".
    items: Contains the data to be displayed in the table.
    Scoped Slot: The #cell(active) slot allows you to customize the rendering of the "Active" column.
    b-form-checkbox: This is used to create a switch. The disabled attribute makes it read-only, preventing user interaction.

Conclusion

This setup allows you to display a read-only switch in a b-table cell, providing a 
clear visual representation of the active status without allowing edits.
muhimasri.com forum.handsontable.com

*/
</script>



<style scoped>
/*
Source - https://stackoverflow.com/a/68252382
Posted by Tahmid Ali, modified by community. See post 'Timeline' for change history
Retrieved 2026-05-25, License - CC BY-SA 4.0
*/

.custom-control-input:checked ~ .custom-control-label::before {
    color: #3b52e9;
    border-color: rgb(28, 237, 28);
    background-color: rgb(28, 237, 28)
 }

</style>